module.exports = __webpack_public_path__ + "static/media/open.0726ff3b.jpeg";